import React, { useEffect, useRef } from 'react';

const MapIframeDrop = ({ latitude, longitude, zoom = 16, onMarkerDrag }) => {
    const mapRef = useRef(null);
    const markerRef = useRef(null);

    useEffect(() => {
        if (!window.google || !latitude || !longitude) return;

        const map = new window.google.maps.Map(mapRef.current, {
            center: { lat: latitude, lng: longitude },
            zoom,
        });

        const marker = new window.google.maps.Marker({
            position: { lat: latitude, lng: longitude },
            map,
            draggable: true,
        });

        marker.addListener('dragend', (e) => {
            const lat = e.latLng.lat();
            const lng = e.latLng.lng();
            onMarkerDrag?.(lat, lng);
        });

        markerRef.current = marker;
    }, [latitude, longitude]);

    return (
        <div ref={mapRef} style={{ width: '100%', height: '100%' }} />
    );
};

export default MapIframeDrop;
